import { Col, Form, Radio, Row } from 'antd';

/**
 * Telif Türü seçimi (`copyright`): mevcut medya önerme (`suggestion`) veya üretim teklifi (`generate`).
 *
 * @param {Object} props
 * @param {boolean} [props.disabled=false] - true ise radyolar salt-okunur olur (seçim değiştirilemez).
 *   Read-only detay modunda (SupervisorEditMediaContent → MediaContentForm) geçilir.
 */
function MediaCopyrightRadioButton({ disabled = false }) {
  return (
    <Form.Item
      className="gx-mt-2"
      label="Telif Türü"
      rules={[
        {
          required: true,
          message: 'Lütfen medya kabul durumunu seçiniz',
        },
      ]}
      name="copyright"
    >
      <Radio.Group
        className="gx-w-100"
        disabled={disabled}
      >
        <Row
          style={{
            flexDirection: 'row',
          }}
          gutter={[24, 6]}
        >
          <Col
            sm={24}
            md={12}
          >
            <Radio
              className="gx-p-2 gx-w-100"
              style={{
                border: '1px solid #f0f0f0',
              }}
              value="suggestion"
            >
              Varolan bir Medyayı önermek / yüklemek istiyorum
            </Radio>
          </Col>
          <Col
            sm={24}
            md={12}
          >
            <Radio
              style={{
                border: '1px solid #f0f0f0',
                marginRight: 0,
              }}
              className="gx-p-2 gx-w-100"
              value="generate"
            >
              Bir medya üretilmesini teklif ediyorum
            </Radio>
          </Col>
        </Row>
      </Radio.Group>
    </Form.Item>
  );
}
export default MediaCopyrightRadioButton;
